import * as actions from '../ActionType/UserActionType';
const initExercise = {
    apiToken:[],
    userList:[],
    newCreateUser:[],
    updatedUser:[],
    deletedUser:[],
    roles:[],
    userDetail:[],
    currentUser:'',
    getAllUser:[],
    errors:[],
    inpersonateList:[]
}
export const UserReducer = (state = initExercise, action:any) => {
    switch (action.type) {
        case actions.TOKEN: 
            return{
                ...state,
                apiToken:action.payload
            };
        case actions.ROLE: 
            return{
                ...state,
                roles:action.payload
            };
        case actions.USER_ALL: 
            return{
                ...state,
                currentUser:action.payload
            };
        case actions.USER_DETAIL: 
            return{
                ...state,
                userDetail:action.payload
            };
        case actions.USER_LIST: 
            return{
                ...state,
                userList:action.payload
            }; 
        case actions.USER_CREATE: 
            return{
                ...state,
                newCreateUser:action.payload
            };
        case actions.USER_UPDATE: 
            return{
                ...state,
                updatedUser:action.payload
            };
        case actions.USER_DELETE: 
            return{
                ...state,
                deletedUser:action.payload
            };
        case actions.GET_ALL_USER_LIST:
            return{
                ...state,
                getAllUser:action.payload
            }
        case actions.INPERSONATE_USER_LIST:
            return{
                ...state,
                inpersonateList:action.payload
            }    
    default:
         return state;
    }
}